export default "assets/images/placement-arrow-e7829c2b.svg";